






// vendor
import { defineComponent, computed, ref, PropType, onMounted, watch, onUnmounted } from "@vue/composition-api";
// project
import { Gallery } from "@/psychlab/types/gallery";
// local
import { useStaticRender } from "../ts/hooks/useStaticRender";

export default defineComponent({

	props:{
		gallery:{
			type:Object as PropType<Gallery>,
			required:true,
		},
		sources:{
			type:Array as PropType<string[]>,
			required:true
		},
	},
	setup(props, context){

		const viewRoot = ref<HTMLElement|null>();
		const mounted = ref(false);

		const {
			fadeInDuration,
			fadeOutDuration,
		} = props.gallery;

		const staticRender = useStaticRender({
			// todo: settings
			fadeInDuration,
			fadeOutDuration,
		});

		const {
			loading,
		} = staticRender;

		const loadCurrent = async() => {
			context.emit("load-start");
			try {
				await staticRender.loadSources(props.sources);
			}
			catch(err){}
			context.emit("load-end");
		};

		onMounted(() => {
			mounted.value = true;
			if(!viewRoot.value){ return; }
			staticRender.init(viewRoot.value);
			loadCurrent();
		});

		onUnmounted(() => {
			staticRender.dispose();
		});

		watch(() => props.sources, v => {
			if(!mounted){ return; }
			loadCurrent();
		});

		return {
			viewRoot,
			loading,
		};
	}
});

